import { NavLink } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import appSelectors from 'redux/app/appSelectors';

import { setDisplayMenu } from 'redux/app/appSlice';

import RouteNames from 'router/routes';

import VpsIcon from 'images/header/vps.svg?react';
import MonitoringIcon from 'images/header/monitoring.svg?react';
import PartnersIcon from 'images/header/partners.svg?react';
import OperationsIcon from 'images/header/operations.svg?react';
import SupportIcon from 'images/header/support.svg?react';
import FaqIcon from 'images/header/faq.svg?react';

import s from './nav.module.css';

function Nav() {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);
  const availablePages = useSelector(appSelectors.availablePages);
  const { partner, monitoring } = availablePages;

  const hideMenu = () => dispatch(setDisplayMenu(false));

  const navlinkStyles = ({ isActive }) =>
    isActive ? s.navlink_active : s.navlink;

  return (
    <ul className={s.navlinks_list}>
      <li>
        <NavLink
          to={RouteNames.VPS}
          onClick={hideMenu}
          className={navlinkStyles}
        >
          <VpsIcon />
          VPS
        </NavLink>
      </li>
      {monitoring === true && (
        <li>
          <NavLink
            to={RouteNames.MONITORING}
            onClick={hideMenu}
            className={navlinkStyles}
          >
            <MonitoringIcon />
            {i18n.Онлайн_мониторинг}
          </NavLink>
        </li>
      )}
      {partner === true && (
        <li>
          <NavLink
            to={RouteNames.PARTNERS}
            onClick={hideMenu}
            className={navlinkStyles}
          >
            <PartnersIcon />
            {i18n.Партнерка}
          </NavLink>
        </li>
      )}
      <li>
        <NavLink
          to={RouteNames.OPERATIONS}
          onClick={hideMenu}
          className={navlinkStyles}
        >
          <OperationsIcon />
          {i18n.Балансовые_операции}
        </NavLink>
      </li>
      <li>
        <NavLink
          to={RouteNames.SUPPORT}
          onClick={hideMenu}
          className={navlinkStyles}
        >
          <SupportIcon />
          {i18n.Поддержка}
        </NavLink>
      </li>
      <li>
        <NavLink
          to={RouteNames.FAQ}
          onClick={hideMenu}
          className={navlinkStyles}
        >
          <FaqIcon />
          FAQ
        </NavLink>
      </li>
    </ul>
  );
}

export default Nav;
